module.exports = __webpack_public_path__ + "img/flask.f56bd7a8.png";